import React, { useState, useEffect } from "react";
import {
    Typography,
    Button,
    Box,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { FormatDate } from "../../../utils/FormatDate";
import { FormatToBrl } from "../../../utils/FormatToBrl";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import HomeIcon from '@mui/icons-material/Home';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { Breadcrumbs, Link } from "@mui/material";
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const cabecalhoSx = { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, color: "#6b7280", textTransform: "uppercase", borderBottom: "none", py: 1 };
const celulaSx = { fontSize: 13, color: "#374151", borderBottom: "1px solid #f3f4f6", py: 1.25 };

const DetalhesCobranca = () => {
    const { user } = useUser();
    const navigate = useNavigate();
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [planos, setPlanos] = useState([]);
    const [assinatura, setAssinatura] = useState(null);

    useEffect(() => {
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;
        setUserActive(!hasFaturasVencidas);
    }, [user]);

    useEffect(() => {
        const getPlano = async () => {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/buscarPlano`,
                {},
                {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`,
                    },
                }
            );
            if (response.data.status === 200) {
                setPlanos(response.data.pagamentos || []);
                setAssinatura(response.data.assinatura);
            }
        };

        getPlano();
    }, []);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/buscarNotificacoes`,
                { email: localStorage.getItem("email") },
                {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`,
                    },
                }
            );

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes);
            }
        };

        getNotify();
    }, []);

    const proximaCobranca = assinatura?.nextDueDate ? FormatDate(assinatura.nextDueDate) : "-";
    const totalPago = planos.reduce((soma, plano) => soma + (Number(plano.value) || 0), 0);

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard/Assinatura")}
                            >
                                <AssignmentTurnedInIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Assinatura & Cobranças
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <DisplaySettingsIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Detalhes de Cobrança
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Detalhes de Cobrança
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Veja sua próxima cobrança e o histórico de pagamentos da sua assinatura.
                        </Typography>
                    </Box>
                    <Button
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate("../Dashboard/Assinatura")}
                        sx={{ alignSelf: { xs: "flex-start", md: "center" }, textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                    >
                        Voltar
                    </Button>
                </Box>

                <Box
                    sx={{
                        mt: 2,
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "minmax(0, 3fr) minmax(0, 1.4fr)" },
                        gap: 2,
                        alignItems: "start",
                    }}
                >
                    {/* Histórico de pagamento */}
                    <Box sx={cardSx}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                            <Box sx={{ width: 36, height: 36, borderRadius: "8px", backgroundColor: "#f3f4f6", color: "#374151", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                <HistoryOutlinedIcon sx={{ fontSize: 20 }} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>Histórico de Pagamento</Typography>
                                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                    {planos.length} {planos.length === 1 ? "pagamento registrado" : "pagamentos registrados"}
                                </Typography>
                            </Box>
                        </Box>

                        <TableContainer sx={{ overflowX: "auto" }}>
                            <Table sx={{ minWidth: 520 }}>
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: "#f3f4f6", "& th:first-of-type": { borderRadius: "6px 0 0 6px" }, "& th:last-of-type": { borderRadius: "0 6px 6px 0" } }}>
                                        <TableCell sx={cabecalhoSx}>Data do pagamento</TableCell>
                                        <TableCell sx={cabecalhoSx}>Forma de pagamento</TableCell>
                                        <TableCell sx={cabecalhoSx} align="right">Valor</TableCell>
                                        <TableCell sx={cabecalhoSx} align="center">Fatura</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {planos.length > 0 ? (
                                        planos.map((plano, index) => {
                                            const isCartao = plano.billingType === "CREDIT_CARD";
                                            return (
                                                <TableRow key={index} hover>
                                                    <TableCell sx={celulaSx}>
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                            <EventOutlinedIcon sx={{ fontSize: 16, color: "#9ca3af" }} />
                                                            {plano.clientPaymentDate ? FormatDate(plano.clientPaymentDate) : "-"}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell sx={celulaSx}>
                                                        <Chip
                                                            icon={isCartao ? <CreditCardIcon /> : <DescriptionOutlinedIcon />}
                                                            label={isCartao ? "Cartão de Crédito" : "Boleto Bancário"}
                                                            size="small"
                                                            sx={{ backgroundColor: "#f3f4f6", color: "#374151", fontWeight: 600, fontSize: 11, height: 22, "& .MuiChip-icon": { fontSize: 14, color: "#6b7280" } }}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ ...celulaSx, fontWeight: 700, color: "#111827", whiteSpace: "nowrap" }} align="right">
                                                        {FormatToBrl(plano.value)}
                                                    </TableCell>
                                                    <TableCell sx={celulaSx} align="center">
                                                        <Button
                                                            size="small"
                                                            startIcon={<VisibilityOutlinedIcon sx={{ fontSize: "16px !important" }} />}
                                                            disabled={!plano.invoiceUrl}
                                                            onClick={() => window.open(plano.invoiceUrl, "_blank")}
                                                            sx={{ textTransform: "none", fontSize: 12, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 1.5, "&:hover": { backgroundColor: "#e5e7eb" } }}
                                                        >
                                                            Exibir fatura
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center" sx={{ borderBottom: "none", py: 6 }}>
                                                <HistoryOutlinedIcon sx={{ fontSize: 36, color: "#d1d5db" }} />
                                                <Typography sx={{ mt: 1, fontSize: 14, fontWeight: 600, color: "#374151" }}>
                                                    Nenhum pagamento registrado.
                                                </Typography>
                                                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                                    Os pagamentos da sua assinatura aparecerão aqui.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        {planos.length > 0 && (
                            <Box sx={{ mt: 2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 1.5, py: 1 }}>
                                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>Total pago no período</Typography>
                                <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{FormatToBrl(totalPago)}</Typography>
                            </Box>
                        )}
                    </Box>

                    {/* Plano e próxima cobrança */}
                    <Box sx={{ position: { md: "sticky" }, top: { md: 80 }, display: "flex", flexDirection: "column", gap: 2 }}>
                        <Box sx={{ ...cardSx, backgroundColor: "#0b243d", border: "none", color: "#fff" }}>
                            <Chip
                                label="Próxima cobrança"
                                size="small"
                                sx={{ backgroundColor: "rgba(255, 200, 69, 0.15)", color: "#ffc845", fontWeight: 700, fontSize: 10, height: 20, letterSpacing: 0.6, textTransform: "uppercase" }}
                            />

                            <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1.5 }}>
                                <Box sx={{ width: 44, height: 44, borderRadius: "10px", backgroundColor: "rgba(255, 255, 255, 0.08)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                    <WorkspacePremiumIcon sx={{ color: "#ffc845", fontSize: 26 }} />
                                </Box>
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography sx={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6 }}>Plano</Typography>
                                    <Typography sx={{ fontSize: 17, fontWeight: 700 }}>{user?.plano?.nome || "..."}</Typography>
                                </Box>
                            </Box>

                            <Box sx={{ mt: 2, backgroundColor: "rgba(255, 255, 255, 0.06)", borderRadius: "10px", p: 1.5 }}>
                                <Typography sx={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6 }}>Valor mensal</Typography>
                                <Typography sx={{ mt: 0.5, fontSize: 26, fontWeight: 700, color: "#ffc845" }}>
                                    {FormatToBrl(user?.plano?.valorNovoMensal || 0)}
                                </Typography>
                                <Box sx={{ mt: 1.5, display: "flex", alignItems: "center", gap: 1 }}>
                                    <EventOutlinedIcon sx={{ fontSize: 18, color: "#94a3b8" }} />
                                    <Typography sx={{ fontSize: 13, color: "#cbd5e1" }}>
                                        Vencimento: <Box component="span" sx={{ color: "#fff", fontWeight: 700 }}>{proximaCobranca}</Box>
                                    </Typography>
                                </Box>
                            </Box>

                            <Button
                                fullWidth
                                variant="contained"
                                startIcon={<SwapHorizIcon />}
                                onClick={() => navigate("../Dashboard/alterarMetodoPagamento")}
                                sx={{ mt: 2.5, py: 1.1, textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#ffc845", borderRadius: "8px", boxShadow: "none", "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" } }}
                            >
                                Alterar método de pagamento
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
        </>
    );
};

export default DetalhesCobranca;
